// extracted by mini-css-extract-plugin
export default {"modal":"BaseModal--modal--cURyY","content":"BaseModal--content--4uJ6j","body":"BaseModal--body--ePynr","save-btn":"BaseModal--save-btn---rIFk","saveBtn":"BaseModal--save-btn---rIFk"};